import { lazy, Suspense, useEffect } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import Layout from './components/Layout'
import Home from './pages/Home'
import { About, Activities, Education, History, Messages, News, NewsDetail, Service } from './pages/ContentPages'
import { ArtifactDetail, Artifacts } from './pages/Artifacts'
import Auth from './pages/Auth'
import Profile from './pages/Profile'
import Settings from './pages/Settings'

const Digital = lazy(() => import('./pages/Digital'))
const VR = lazy(() => import('./pages/VR'))

function ScrollManager() {
  const { pathname, hash } = useLocation()
  useEffect(() => {
    document.title = `${routeTitles[pathname] || '数字纪念馆'}｜沈阳九一八历史博物馆`
    if (hash) window.setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth' }), 80)
    else window.scrollTo({ top: 0 })
  }, [pathname, hash])
  return null
}

const routeTitles: Record<string, string> = {
  '/': '首页', '/about': '走进博物馆', '/history': '历史记忆', '/digital': '数字展馆', '/vr': 'VR沉浸体验', '/artifacts': '文物数字展示', '/news': '新闻资讯', '/activities': '纪念活动', '/education': '教育资源', '/service': '开放与服务', '/messages': '留言互动', '/profile': '个人中心', '/settings': '设置', '/auth': '登录注册',
}

export default function App() {
  return (
    <>
      <ScrollManager />
      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/history" element={<History />} />
          <Route path="/artifacts" element={<Artifacts />} />
          <Route path="/artifacts/:id" element={<ArtifactDetail />} />
          <Route path="/news" element={<News />} />
          <Route path="/news/:id" element={<NewsDetail />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/education" element={<Education />} />
          <Route path="/service" element={<Service />} />
          <Route path="/messages" element={<Messages />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/digital" element={<Suspense fallback={<PageLoader />}><Digital /></Suspense>} />
        </Route>
        <Route path="/vr" element={<Suspense fallback={<PageLoader />}><VR /></Suspense>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  )
}

const PageLoader = () => <div className="page-loader" role="status"><span />正在载入数字展馆…</div>
